// extracted by mini-css-extract-plugin
export default {"rectangular":"Loader_rectangular__ncKsp"};